import { z } from "zod"

const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/

export const organizationBrandingSchema = z.object({
  primaryColor: z
    .string()
    .regex(hexColorRegex, "Must be a valid hex color (e.g., #1890ff)")
    .nullable(),
  secondaryColor: z
    .string()
    .regex(hexColorRegex, "Must be a valid hex color (e.g., #52c41a)")
    .nullable(),
  accentColor: z
    .string()
    .regex(hexColorRegex, "Must be a valid hex color (e.g., #fa541c)")
    .nullable(),
})

export type OrganizationBrandingFormData = z.infer<
  typeof organizationBrandingSchema
>
